<template>
  <div class="empty-contanier">
    <img src="@/assets/img/pic_no_ranking.png" alt="">
    <div>暂无排名数据</div>
  </div>
</template>

<script>
export default {
  name: 'Empty',
  data() {
    return {}
  }
}
</script>

<style lang="less" scoped>
.empty-contanier {
  img {
    width: 160px;
    height: 137px;
    margin-bottom: 16px;
  }
}
</style>